export const FETCH_PLACES_DATA = "FETCH_PLACES_DATA";
export const FETCH_PLACES_SUCCESS = "FETCH_PLACES_SUCCESS";
export const FETCH_PLACES_FAILURE = "FETCH_PLACES_FAILURE";

export const FETCH_PLACES_EDIT_DATA = "FETCH_PLACES_EDIT_DATA";
export const FETCH_PLACES_EDIT_SUCCESS = "FETCH_PLACES_EDIT_SUCCESS";
export const FETCH_PLACES_EDIT_FAILURE = "FETCH_PLACES_EDIT_FAILURE";